var closeAll = function(){
    document.getElementById('recover-password').style.display = 'none';
    document.getElementById('login_form').style.display = 'block';
    $('#login_form').removeClass('active');
    $('.register_link').removeClass('active');
};

var openArea = function(target){
    target.addClass('active');
};

$('#login_form h1').click(function(){
    closeAll();
    openArea( $('#login_form') );
});

$('.register_link h1').click(function(){
    closeAll();
    openArea( $('.register_link') );
});